import { createContext, useContext, useState } from "react";
import { noop } from "lodash";

interface EventsContextProp {
  isAutoRsvpInvitedAttendees: boolean;
  isEmailNotificationsEnabled: boolean;
  isUpdatingAttendees: boolean;
  setIsAutoRsvpInvitedAttendees: (param: boolean) => void;
  setIsEmailNotificationsEnabled: (param: boolean) => void;
  setIsUpdatingAttendees: (param: boolean) => void;
}

const EventsContext = createContext<EventsContextProp>({
  isUpdatingAttendees: false,
  setIsUpdatingAttendees: noop,
  isEmailNotificationsEnabled: false,
  setIsEmailNotificationsEnabled: noop,

  isAutoRsvpInvitedAttendees: false,
  setIsAutoRsvpInvitedAttendees: noop,
});

EventsContext.displayName = "EventsContext";

export const useEventsContext = () => useContext(EventsContext);

export const EditEventContext = ({ children }: any) => {
  const [isUpdatingAttendees, setIsUpdatingAttendees] = useState(false);
  const [isEmailNotificationsEnabled, setIsEmailNotificationsEnabled] =
    useState(true);
  const [isAutoRsvpInvitedAttendees, setIsAutoRsvpInvitedAttendees] =
    useState(false);

  return (
    <EventsContext.Provider
      value={{
        isUpdatingAttendees,
        setIsUpdatingAttendees,
        isEmailNotificationsEnabled,
        setIsEmailNotificationsEnabled,
        isAutoRsvpInvitedAttendees,
        setIsAutoRsvpInvitedAttendees,
      }}
    >
      {children}
    </EventsContext.Provider>
  );
};
